export class UserType {
    public static SystemAdmin:string = 'System Administrator';
    public static CentreAdmin:string = 'Centre Administrator';
    public static CentreUser:string = 'Centre User';
    public static Practitioner:string = 'Practitioner';
    public static Nurse:string = 'Nurse';
    public static Tmb:string = 'Tmb';
    public static Patient:string = 'Patient';
}

export const AccessUrl = [
    {url: '/consultation/waiting-room', permission: 'page.waitingroom'},
    {url: '/consultation/previous-waiting-room', permission: 'page.waitingroom'},
    {url: '/consultation/search-patient', permission: 'page.searchpatient'},
    {url: '/consultation/result-search-patient', permission: 'page.searchpatient'},
    {url: '/consultation/cash-sale', permission: 'page.cashsale'},
    {url: '/consultation/cash-sale/invoice/:patientId/:isFromHistory', permission: 'page.cashsale'},
    {url: '/consultation/cash-sale/:id/:patientId', permission: 'page.cashsale'},
    {url: '/consultation/cash-sale/:id/:patientId/:isFromHistory', permission: 'page.cashsale'},
    {url: '/booking/manage-booking', permission: 'page.managebooking'},
    {url: '/booking/request-appointment', permission: 'page.managebooking'},
    {url: '/booking/list-member', permission: 'page.managebooking'},
    {url: '/centre/news', permission: 'page.newsmemo'},
    {url: '/centre/manage-memo', permission: 'page.managenewsmemo'},
    {url: '/centre/patient-information/:id', permission: 'page.waitingroom'},
    {url: '/centre/manage-centre', permission: 'page.managecentre'},
    {url: '/centre/manage-user', permission: 'page.managecentreuser'},
    {url: '/centre/register-user', permission: 'page.registeruser'},
    {url: '/centre/assign-user', permission: 'page.addusertocentre'},
    {url: '/centre/manage-price', permission: 'page.manageprice'},
    {url: '/centre/manage-vaccine', permission: 'page.managevaccinestock'},
    {url: '/centre/manage-company-accounts', permission: 'page.managecompanyaccount'},
    {url: '/centre/manage-patient', permission: 'page.managepatientuser'},
    {url: '/report/report-all', permission: 'page.report'},
    {url: '/payment/account-payment', permission: 'page.accountpayment'},
    {url: '/master-data/medical-categories', permission: 'page.medicalconditioncategory'},
    {url: '/master-data/medical', permission: 'page.medicalcondition'},
    {url: '/master-data/presciption-categories', permission: 'page.presciptioncategory'},
    {url: '/master-data/presciption', permission: 'page.prescription'},
    {url: '/master-data/labtest-categories', permission: 'page.labtestcategory'},
    {url: '/master-data/labtest', permission: 'page.labtest'},
    {url: '/master-data/regions', permission: 'page.region'},
    {url: '/master-data/countries', permission: 'page.country'},
    {url: '/master-data/diseases', permission: 'page.disease'},
    {url: '/master-data/countries-diseases', permission: 'page.countrydisease'},
    {url: '/master-data/suppliers', permission: 'page.supplier'},
    {url: '/master-data/vaccines', permission: 'page.vaccine'},
    {url: '/master-data/diseases-vaccines', permission: 'page.diseasevaccine'},
    {url: '/master-data/medical-conditions-vaccines', permission: 'page.medicalconditionvaccine'},
    {url: '/master-data/product-categories', permission: 'page.productcategory'},
    {url: '/master-data/products', permission: 'page.product'},
    {url: '/master-data/consultations', permission: 'page.consultation'},
    {url: '/master-data/email-domains', permission: 'page.emaildomain'},
    {url: '/master-data/centre-management-fees', permission: 'page.centremanagementfee'},
    {url: '/master-data/manage-memo-mytmb', permission: 'page.managenewsmemo'},
    // Feature CR06
    // {url: '/master-data/clinics', permission: 'page.manageclinic'},
    // {url: '/master-data/clinic-type', permission: 'page.clinictype'},
    // {url: '/master-data/reasons', permission: 'page.reason'},
    // {url: '/master-data/clinic-schedule/:clinicId', permission: 'page.reason'},
    {url: '/consultation-process/patient-detail/:id/:patientId', permission: 'page.consultationprocess.patientdetail'},
    {url: '/consultation-process/trip-information/:id/:patientId', permission: 'page.consultationprocess.tripinformation'},
    {url: '/consultation-process/trip-information/:id', permission: 'page.consultationprocess.tripinformation'},
    {url: '/consultation-process/medical-conditions/:id/:patientId', permission: 'page.consultationprocess.medicalcondition'},
    {url: '/consultation-process/record-previous-vaccines/:id/:patientId', permission: 'page.consultationprocess.recordpreviousvaccine'},
    {url: '/consultation-process/select-disease/:id/:patientId', permission: 'page.consultationprocess.selectdisease'},
    {url: '/consultation-process/prescribe-vaccination/:id/:patientId', permission: 'page.consultationprocess.prescribevaccination'},
    {url: '/consultation-process/select-prescriptions/:id/:patientId', permission: 'page.consultationprocess.selectprescription'},
    {url: '/consultation-process/lab-tests/:id/:patientId', permission: 'page.consultationprocess.labtest'},
    {url: '/consultation-process/save-consultation/:id/:patientId', permission: 'page.consultationprocess.saveconsultation'},
    {url: '/consultation-process/administer-vaccine/:id/:patientId', permission: 'page.consultationprocess.administervaccination'},
    {url: '/consultation-process/confirmation-lab-tests/:id/:patientId', permission: 'page.consultationprocess.confirmationlabtest'},
    {url: '/consultation-process/group-recommended-diseases/:id', permission: 'page.consultationprocess.recommendeddisease'},
    {url: '/consultation-process/group-recommended-prescriptions/:id', permission: 'page.consultationprocess.recommendedprescriptione'},
    {url: '/consultation-process/group-recommended-lab-tests/:id', permission: 'page.consultationprocess.recommendedlabtest'},
    {url: '/consultation-process/group-template-trip-information/:id', permission: 'page.consultationprocess.templatetripinformation'},
    {url: '/consultation-process/group-template-recommended-diseases/:id', permission: 'page.consultationprocess.templatedisease'},
    {url: '/consultation-process/group-template-recommended-prescriptions/:id', permission: 'page.consultationprocess.templateprescriptione'},
    {url: '/consultation-process/group-template-recommended-lab-tests/:id', permission: 'page.consultationprocess.templatelabtest'},
    {url: '/news',  permission: 'page.newsmemo'}
];



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/shared/constants/permission.ts